import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { KeycloakService } from 'keycloak-angular';
import { Observable, defer, from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private readonly keycloak: KeycloakService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // Add Keycloak token only to backend API requests.
    if (!this.isApiRequest(request.url)) {
      return next.handle(request);
    }

    const keycloakInstance = this.keycloak.getKeycloakInstance();

    return defer(() => from(keycloakInstance.updateToken(30))).pipe(
      catchError((error: unknown) => {
        console.error('Keycloak token refresh failed:', error);

        void this.keycloak.login();

        return throwError(() => error);
      }),

      switchMap(() => {
        const token = keycloakInstance.token;

        if (!token) {
          console.error('Keycloak access token is unavailable.');
          return next.handle(request);
        }

        const authenticatedRequest = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });

        return next.handle(authenticatedRequest);
      }),
    );
  }

  private isApiRequest(url: string): boolean {
    return url.startsWith('/api/');
  }
}